import React, { PureComponent, Fragment, Component } from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faCheck, faTimes, faHeadphones, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import SpeechRecognition from 'react-speech-recognition';

import { Wrapper } from './style';
import { master } from '../../assets/main';
import Layout from '../Layout';
import * as routes from '../../constants/routes';

class LevelGame extends PureComponent {
  constructor() {
    super();
    this.state = {
      spelling: '',
      hint: false,
    };
  }

  handleHint = () => {
    this.setState((prev) => ({ hint: !prev.hint }));
  };

  onChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onSubmit = (event, { nextLevel, nextGame, hasNext, lastQ }) => {
    event.preventDefault();
    const { spelling } = this.state;
    const { match, handleAnswer } = this.props;
    const { level, game } = match.params;

    const { word } = master.levelsObject[level - 1][game - 1];
    if (spelling === word) {
      handleAnswer({ isCorrect: true, nextLevel, nextGame, hasNext, lastQ });
    } else {
      handleAnswer({ isCorrect: false, nextLevel, nextGame, hasNext, lastQ });
    }
    this.setState({ spelling: '' });
  };

  handlePlay = async () => {
    const { match } = this.props;
    const { level, game } = match.params;
    const audioLink = master.levelsObject[level - 1][game - 1].audio;
    const sound = new Audio(audioLink);

    sound.play();
  };

  render() {
    const { match, handleAnswer, correct, wrong, points } = this.props;
    const reponseScreen = correct || wrong;
    const { level, game } = match.params;

    if (
      !master.levelsObject[level - 1] ||
      !master.levelsObject[level - 1][game - 1] ||
      typeof +level !== 'number' ||
      typeof +game !== 'number'
    ) {
      return <Redirect to={'/'} />;
    }

    const theArray = master.levelsObject[level - 1][game - 1];
    const levelLength = master.levelsObject.length - 1;
    const gameLength = master.levelsObject[level - 1].length - 1;
    let nextLevel;
    let nextGame;
    let hasNext = false;
    let lastQ = false;

    // If last game, check if there is a next level
    if (+game - 1 === gameLength && +level - 1 < levelLength) {
      nextLevel = +level + 1;
      hasNext = true;
    } else {
      nextLevel = level;
    }
    if (+game - 1 < gameLength) {
      nextGame = +game + 1;
      hasNext = true;
    } else {
      nextGame = 1;
    }
    // If last question update lastQ variable so user redirects to homepage in Wrapper component
    if (+level - 1 === levelLength && +game - 1 === gameLength) {
      lastQ = true;
    }

    const { transcript, browserSupportsSpeechRecognition, listening, startListening } = this.props;
    const { spelling, hint } = this.state;

    return (
      <Layout points={points}>
        <Wrapper active={listening}>
          <div id="play-section">
            {theArray.type === 'Pronoucing' && (
              <Fragment>
                {browserSupportsSpeechRecognition ? (
                  <Fragment>
                    <h3 className="the-word">{theArray.word}</h3>
                    <button className="play-button play-button-record" onClick={() => startListening()}>
                      {listening ? (
                        <Fragment>
                          <FontAwesomeIcon icon={faHeadphones} />
                          Recording
                        </Fragment>
                      ) : (
                        'Click to record yourself'
                      )}
                    </button>
                    <SpeechLogicWrapper
                      word={theArray.word}
                      transcript={transcript}
                      handleAnswer={handleAnswer}
                      nextLevel={nextLevel}
                      nextGame={nextGame}
                      hasNext={hasNext}
                      lastQ={lastQ}
                    />
                  </Fragment>
                ) : (
                  <p>Pronoucing is only available in Chrome browsers.</p>
                )}
              </Fragment>
            )}
            {theArray.type === 'Listening' && (
              <Fragment>
                <button className="play-button play-button-play" onClick={() => this.handlePlay()}>
                  Play Audio
                </button>
                <div className="flex">
                  <OptionLogicWrapper
                    transcript={transcript}
                    theArray={theArray}
                    handleAnswer={handleAnswer}
                    nextLevel={nextLevel}
                    nextGame={nextGame}
                    hasNext={hasNext}
                    lastQ={lastQ}
                  />
                </div>
              </Fragment>
            )}
            {theArray.type === 'Spelling' && (
              <Fragment>
                <button className="play-button play-button-play" onClick={() => this.handlePlay()}>
                  Play Audio
                </button>
                {!hint && (
                  <div id="hint-section" onClick={() => this.handleHint()}>
                    <img src="/static/img/blue-bird.png" alt="blue bird hint" />
                    <p>Show hint</p>
                  </div>
                )}
                {hint && (
                  <p className="the-hint">
                    <FontAwesomeIcon icon={faFileAlt} />
                    {theArray.description}
                  </p>
                )}
                <form onSubmit={(event) => this.onSubmit(event, { nextLevel, nextGame, hasNext, lastQ })}>
                  <input
                    onChange={this.onChange}
                    name="spelling"
                    value={spelling}
                    placeholder="Input the spelling here"
                  />
                  <button type="submit">Check Spelling</button>
                </form>
              </Fragment>
            )}
            {reponseScreen && (
              <div id="response-overlay">
                {correct ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faTimes} />}
              </div>
            )}
          </div>
          <Link id="back-link" to={routes.MAIN}>
            <FontAwesomeIcon icon={faChevronCircleLeft} /> Back to main
          </Link>
        </Wrapper>
      </Layout>
    );
  }
}

class SpeechLogicWrapper extends Component {
  componentDidUpdate(prevProps) {
    const { word, transcript, handleAnswer, nextLevel, nextGame, hasNext, lastQ } = this.props;
    if (prevProps.transcript !== transcript) {
      if (transcript.length > 0) {
        clearTimeout(this.timout);
        this.timout = setTimeout(() => {
          if (transcript === word.toLowerCase()) {
            handleAnswer({ isCorrect: true, nextLevel, nextGame, hasNext, lastQ });
          } else {
            handleAnswer({ isCorrect: false, nextLevel, nextGame, hasNext, lastQ });
          }
        }, 2000);
      }
    }
  }

  render() {
    return <div></div>;
  }
}

class OptionLogicWrapper extends Component {
  componentDidUpdate(prevProps) {
    const { transcript, handleAnswer } = this.props;
    if (prevProps.transcript !== transcript) {
      const spokenWord = document.querySelector(`.options-${transcript}`);

      if (transcript.length > 0) {
        clearTimeout(this.timout);
        this.timout = setTimeout(() => {
          if (spokenWord) {
            spokenWord.click();
          } else {
            handleAnswer({ isCorrect: false });
          }
        }, 2000);
      }
    }
  }

  render() {
    const { theArray, handleAnswer, nextLevel, nextGame, hasNext, lastQ } = this.props;
    return (
      <Fragment>
        {theArray.options.map((object, objectIndex) => {
          return (
            <button
              key={objectIndex}
              className={`options options-${object.text.toLowerCase()}`}
              onClick={() => handleAnswer({ isCorrect: object.bool, nextLevel, nextGame, hasNext, lastQ })}
            >
              {object.text}
            </button>
          );
        })}
      </Fragment>
    );
  }
}

const options = {
  autoStart: false,
  continuous: false,
};
export default withRouter(SpeechRecognition(options)(LevelGame));
